import { For, useContext } from 'solid-js';
import { FirstLevelMenuItemLink } from './first-level-menu-item-link/first-level-menu-item-link';
import { FirstLevelMenu } from './first-level-menu/first-level-menu';
import { AppContext } from '../../../../app-context-provider/app-context-provider';

import type { MenuItem, PrimaryMenuProps } from '../../menu-types';

/* Root list of top-level menu items. Slide animation + sub-view are handled
   upstream in MenuMobile; this component just renders the left pane's content. */
export const PrimaryMenu = (props: PrimaryMenuProps) => {
    const { appStore } = useContext(AppContext);
    const { close } = appStore;

    return (
        <ul class="flex flex-col pt-cvi-6">
            <For each={props.menu}>
                {(menuItem: MenuItem) => (
                    menuItem.children
                        ? <FirstLevelMenu parent={menuItem} onDrillIn={props.setActiveParent} />
                        : <li class="pb-0"><FirstLevelMenuItemLink link={menuItem} onLinkClick={close} /></li>
                )}
            </For>
        </ul>
    );
};
